import axios from 'axios';
import { hostServer } from './consts/host';
import { changeFetchInProg } from './fetchInProgress';
import _ from 'lodash';
import { message } from 'antd';

export const setTransactions = (transactions) => ({
  type: 'SET_TRANSACTIONS',
  transactions,
});

export const startGetFinance = () => {
  return async (dispatch, getState) => {
    const json = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    dispatch(changeFetchInProg(true));
    try {
      const { data } = await axios.get(
        `${hostServer}/api/v1/users/financial_transactions`,
        json
      );

      dispatch(
        setTransactions(
          _.map(data, (el) => {
            return _.omit(el, 'user');
          })
        )
      );
    } catch (e) {
      console.log(e);
    }
    dispatch(changeFetchInProg(false));
  };
};

export const startPaying = (
  amount,
  goal = 'charge',
  planName = undefined,
  period
) => {
  return async (dispatch, getState) => {
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    const json = {
      amount,
    };
    dispatch(changeFetchInProg(true));
    try {
      const { data } = await axios.post(
        `${hostServer}/api/v1/users/zarinpal/request?goal=${goal}${
          planName ? `&plan_name=${planName}&period=${period}` : ''
        }`,
        json,
        header
      );
      // similar behavior as clicking on a link
      window.location.href = data.redirect_url;
    } catch (e) {
      console.log(e);
    }
    dispatch(changeFetchInProg(false));
  };
};

export const addCredit = (
  amount,
  description = 'Credit added from console'
) => {
  return async (dispatch, getState) => {
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    const json = {
      user_email: getState().auth.email,
      amount: amount,
      description: description,
    };
    dispatch(changeFetchInProg(true));
    try {
      const { data } = await axios.post(
        `${hostServer}/api/v1/users/add_credit`,
        json,
        header
      );

      // Show success message
      if (data.success) {
        
        message.success(
          `اعتبار ${amount.toLocaleString()}  تومان با موفقیت اضافه شد حالا  میتوانید پلن خود را انتخاب کنید`
        );
        // Refresh the finance data to show updated balance
        dispatch(startGetFinance());
      }
    } catch (e) {
      console.error('Error adding credit:', e);

      // Handle different error types with user-friendly messages
      if (e.response) {
        const errorData = e.response.data;
        if (e.response.status === 404) {
          message.error('کاربر یافت نشد. لطفاً دوباره وارد شوید.');
        } else if (e.response.status === 400) {
          const errorMsg = errorData.error || 'درخواست نامعتبر';
          if (errorMsg.includes('organization')) {
            message.error('شما باید ابتدا حساب خود را به کنسول متصل کنید.');
          } else {
            message.error(`خطا: ${errorMsg}`);
          }
        } else if (e.response.status === 401) {
          message.error('احراز هویت نامعتبر. لطفاً دوباره وارد شوید.');
        } else if (e.response.status === 403) {
          message.error('شما مجوز انجام این عملیات را ندارید.');
        } else {
          message.error('خطای سرور. لطفاً بعداً تلاش کنید.');
        }
      } else if (e.request) {
        message.error('خطا در اتصال به سرور.');
      } else {
        message.error('خطای غیرمنتظره. لطفاً دوباره تلاش کنید.');
      }
    }
    dispatch(changeFetchInProg(false));
  };
};
